import { LocalDate } from '@js-joda/core';

import { Bean, FieldControllerProps, ValidationRules } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { medicalLeaveTranslationKeys } from '../../../../../../translations';

const VALIDATION_RULES: ValidationRules<Bean> = {
   required: true,
};

type PassportValidToFieldProps = FieldControllerProps<'passportValidTo', LocalDate | null>;

export const PassportValidToField = (props: PassportValidToFieldProps): JSX.Element => {
   return (
      <DatePicker
         testId={'passportValidTo'}
         controller={props.register('passportValidTo', VALIDATION_RULES)}
         defaultValue={null}
         dayValidators={'dayBeforeToday'}
         label={medicalLeaveTranslationKeys.personalData.passportValidTo.label}
         placeholder={medicalLeaveTranslationKeys.personalData.passportValidTo.placeholder}
         withNavigationArrows
      />
   );
};
